import { LogoLink } from '@audio-network/componentlibrary'
import YourLibrary from './YourLibrary/YourLibrary'
import clsx from 'clsx'
import styles from './Sidebar.module.css'
import { useSidebarResize } from './Sidebar.hooks'
import { useTranslation } from 'next-i18next'

const Sidebar: React.FC = (props) => {
	const {
		handleKeyDown,
		handleResizeStart,
		sidebarContentRef,
		expanded,
		handleTransitionEnd,
		stopLogoPropagation,
	} = useSidebarResize()

	const { t } = useTranslation(['navigation'])

	return (
		<aside className={styles.sidebar} {...props}>
			<div
				className={clsx(styles.sidebarContent, expanded && styles.expanded)}
				onTransitionEnd={handleTransitionEnd}
				ref={sidebarContentRef}
			>
				<LogoLink
					aria-label="Audio Network"
					className={clsx(
						styles.logoLink,
						styles.roundel,
						styles.hideWhenExpanded
					)}
					color="yellow"
					href="/"
					onTransitionEnd={stopLogoPropagation}
					roundel
					tabIndex={-1}
				/>
				<LogoLink
					aria-label="Audio Network"
					className={clsx(
						styles.logoLink,
						styles.logo,
						styles.showWhenExpanded
					)}
					color="white"
					href="/"
					onTransitionEnd={stopLogoPropagation}
					tabIndex={-1}
				/>
				<YourLibrary />
			</div>

			<div
				aria-label={t('resize-navigation-drawer')}
				className={styles.sidebarDrag}
				onKeyDown={handleKeyDown}
				onMouseDown={handleResizeStart}
				role="button"
				tabIndex={0}
			/>
		</aside>
	)
}

export default Sidebar
